import { State, moveTo, setValue } from '@btime/state-monad'
import { curry } from 'ramda'
import { useOnUnload } from '@btime/react-hooks'
import React, { useCallback, useContext, useReducer } from 'react'

import { Reducer } from '../../../../utils/reducer/chain'
import { generateContext } from '@btime/react-contexts'
import { handleState } from '../../../../utils/reducer/basicStateHandler'
import { useQueryParams } from '../../../../utils/contexts/UrlProvider'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useSendFormState = () => useContext(StateContext)
export const useSendFormActions = () => useContext(ActionsContext)

const initialState = {
  places: [],
  form: {},
  placeField: {}
}

const SET_FIELD_VALUE = 'SET_FIELD_VALUE'

const reducer = (state, action) =>
  Reducer(state, action)
    .map(
      handleState(SET_FIELD_VALUE, (state, action) => {
        const { field, value } = action.payload

        return State.of({ ...state })
          .map(moveTo(field))
          .map(setValue(value))
          .fold()
      })
    )

    .foldState()

const Form = ({ children }) => {
  const { formId, formName } = useQueryParams()
  let finalInitialState = initialState
  if (formId) finalInitialState = { ...finalInitialState, form: { id: formId, name: formName } }
  const [state, dispatch] = useReducer(reducer, finalInitialState)
  useOnUnload({ condition: !!state.touched })

  const open = !!state.places.length

  const handleChange = useCallback(
    curry((field, value) => dispatch({ type: SET_FIELD_VALUE, payload: { field, value } })),
    [dispatch]
  )

  const openSendFormModal = useCallback(handleChange('places'), [handleChange])
  const closeSendFormModal = useCallback(() => handleChange('places', []), [handleChange])

  return (
    <Provider
      state={{ ...state, open }}
      actions={{
        handleChange,
        openSendFormModal,
        closeSendFormModal
      }}
    >
      {children}
    </Provider>
  )
}

export default Form
